import { createAsyncThunk } from "@reduxjs/toolkit"
import { CreateWorkflowDefinition, WorkflowDefinition, WorkflowStep } from "./workflowTypes"
import { AppThunkAPIType } from "../../../../app/appTypes"
import { getWithAuth, postWithAuth, putWithAuth } from "../../../../http"


export const loadWorkflowDefinitions = createAsyncThunk<WorkflowDefinition[], void, AppThunkAPIType>(
    "workflow-definitions/load-all", async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: `api/workflow-definitions` }))
        const { payload } = result

        if (getWithAuth.fulfilled.match(result)) {
            return payload as WorkflowDefinition[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })


export const loadWorkflowDefinition = createAsyncThunk<WorkflowDefinition, string, AppThunkAPIType>(
    "workflow-definitions/load-one", async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: `api/workflow-definitions/${id}`,
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as WorkflowDefinition
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const loadWorkflowDefinitionSteps = createAsyncThunk<WorkflowStep[], string, AppThunkAPIType>(
    "workflow-definitions-steps/load", async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({
            url: `api/workflow-definitions/${id}/steps`,
        }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as WorkflowStep[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })



export const createWorkflowDefinition = createAsyncThunk<WorkflowDefinition, CreateWorkflowDefinition, AppThunkAPIType>(
    "workflow-definitions/create",
    async (data: CreateWorkflowDefinition, { rejectWithValue, dispatch }) => {
        const result = await dispatch(postWithAuth({
            url: "api/workflow-definitions",
            payload: data,
        }))
        const { payload } = result

        if (postWithAuth.fulfilled.match(result)) {
            return payload as WorkflowDefinition
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    }
)

export const updateWorkflowDefinitionSteps = createAsyncThunk<WorkflowStep[], { id: string; steps: WorkflowStep[] }, AppThunkAPIType>(
    "workflow-definitions-steps/update",
    async ({ id, steps }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(putWithAuth({
            url: `api/workflow-definitions/${id}/steps`,
            payload: { steps },
        }));
        const { payload } = result;
        if (putWithAuth.fulfilled.match(result)) {
            return payload as WorkflowStep[];
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);